const webEnquiriesCreatedTemplate = `
<div class="ui-notification">
  <h3>Web Enquiries Created</h3>
  <div class="message">
    {{count}} new web enquiries received. Click on to go do Dashboard
    <br />  

    <a class="btn btn-success" ui-srefx="dashboard" ng-click="viewDashoard()">View Dashboard</a>
  </div>
</div>
`;

export default webEnquiriesCreatedTemplate;



// WEBPACK FOOTER //
// ./client/app/common/templates/notification/webEnquiriesCreatedTemplate.js